import type { MsrPurchaseOrderEmail } from '~/api/order';
import { OutboundEmailStatus } from '~/graphql/graphql';

export const countsAsEmailed = (email: MsrPurchaseOrderEmail) =>
  email.status !== OutboundEmailStatus.Failed;
